<template>
   
      <div class="bg-white overflow-hidden shadow-sm  py-2 sm:rounded-xs border my-3">
                  <!-- Time & Attendance Checkin start from here -->
            <div class="flex justify-between mx-3 mt-2">
                <div>
                <h2 class="font-semibold text-lg text-gray-800 leading-tight">Check In / Out</h2>
                <p class="text-xs">{{ formattedDate }}</p>
                </div>

                <!-- Time & Attendance checkin button end -->
                <div>
                    <button
                        v-if="currentButton === 'initialCheckin'"
                        @click="checkIn"
                        class="content-center text-xs text-green-600 border-2 border-green-600 flex bg-transparent text-green-700 font-semibold py-2 px-3  rounded"
                    >
                        <img :src="'/imgs/clock.png'" alt="" class="" />
                        &nbsp; 
                        <p class="flex flex-wrap content-end">Check In</p>
                    </button>
                    <button
                        v-if="currentButton === 'checkedin'"
                        @click="checkOut"
                        class="content-center text-xs text-red-600 border-2 border-red-600 flex bg-transparent font-semibold  py-2 px-3 rounded"
                    >   
                        <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 1024 1024"><path fill="currentColor" d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8c-7 8.5-14.5 16.7-22.4 24.5a353.8 353.8 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.8 353.8 0 0 1-112.7-75.9a353.3 353.3 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8s94.3 9.3 137.9 27.8c42.2 17.8 80.1 43.4 112.7 75.9c7.9 7.9 15.3 16.1 22.4 24.5c3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82C271.7 82.6 79.6 277.1 82 516.4C84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7c3.4-5.3-.4-12.3-6.7-12.3m88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6"/></svg>
                        &nbsp;
                        <p class="flex flex-wrap content-end">Check Out</p>      
                    </button>
                    <button
                        v-if="currentButton === 'checkout'"
                        
                        :class="['content-center', 'text-xs', 'text-gray-500', 'border-2', 'border-gray-300', 'flex', 'bg-transparent', 'font-semibold',  'py-2', 'px-3', 'rounded', 'cursor-not-allowed', { 'disabled': isCheckoutDisabled }]"
                         :disabled="isCheckoutDisabled"
                    >   
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 1024 1024"><path fill="currentColor" d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8c-7 8.5-14.5 16.7-22.4 24.5a353.8 353.8 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.8 353.8 0 0 1-112.7-75.9a353.3 353.3 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8s94.3 9.3 137.9 27.8c42.2 17.8 80.1 43.4 112.7 75.9c7.9 7.9 15.3 16.1 22.4 24.5c3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82C271.7 82.6 79.6 277.1 82 516.4C84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7c3.4-5.3-.4-12.3-6.7-12.3m88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6"/></svg>
                        &nbsp;
                        <p class="flex flex-wrap content-end">Check Out</p>      
                    </button>
                </div>
            </div>
            <!-- Time & Attendance checkin end -->

            <!-- checkin checkout time start -->
            <div class="flex justify-between m-3">
            <div class="pl-3 pr-5 py-2 bg-green-50 text-xs">
             <p class="text-gray-600">check In</p> 
             <p v-if="CheckIn" class="text-sm text-semibold">{{ CheckIn }}</p>
            </div>

            <div class="pl-3 pr-5 py-2 bg-red-50 text-xs">
               <p class="text-gray-600">check Out</p>
               <p v-if="CheckOut" class="text-sm text-semibold">{{ CheckOut }}</p>
            </div>
            </div>

          <div class="mx-3 mb-2">
            <div class="px-3 py-2 bg-blue-50 text-xs text-center">
              <p class="text-gray-600">Working Hour</p> 
              <p v-if="workingHours" class="text-sm text-semibold"> {{ workingHours }}</p>
            </div>
          </div>
           
            <!-- checkin checkout time end -->
      </div>
   
</template>

<script >
import JetButton from '@/Jetstream/Button.vue'
export default {
    components: {
      JetButton,
    },
    
    data() {
      
    return {
      currentButton: 'initialCheckin',
      isCheckoutDisabled: true,
        CheckIn:  '00:00:00',
        CheckOut:  '00:00:00',
      date: new Date()
    };
  },

  methods: {
    checkIn() {
      this.currentButton = 'checkedin';
       const currentDate = new Date();
      this.CheckIn = currentDate.toLocaleTimeString('en-US', { hour12: true });
    },
    checkOut() {
      this.currentButton = 'checkout';
      const currentDate = new Date();
          this.CheckOut = currentDate.toLocaleTimeString('en-US', { hour12: true });
    },
    
        convertTo24Hour(timeStr) {
          let [time, modifier] = timeStr.split(' ');
          console.log('time modifier ' + time, modifier)
          let [hours, minutes, seconds] = time.split(':').map(Number);
          if (modifier === 'PM' && hours !== 12) {
            hours += 12;
          }
          if (modifier === 'AM' && hours === 12) {
            hours = 0;
          }
          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },
  },
  computed: {
    formattedDate() {
      const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      return this.date.toLocaleDateString('en-US', options);
    },
    // calculation of workingHours between in and out
    workingHours() {
  if (this.CheckIn !== '00:00:00' && this.CheckOut !== '00:00:00') {
    console.log("checkin & checkout" + this.CheckIn, this.CheckOut);

    const formattedCheckIn = this.convertTo24Hour(this.CheckIn);
    const formattedCheckOut = this.convertTo24Hour(this.CheckOut);
  
    const [inHours, inMinutes, inSeconds] = formattedCheckIn.split(':').map(Number);
    console.log("time in " + inHours, inMinutes, inSeconds);
    const [outHours, outMinutes, outSeconds] = formattedCheckOut.split(':').map(Number);
    console.log("time out " + outHours, outMinutes, outSeconds);

    
    const checkinDate = new Date();
    checkinDate.setHours(inHours, inMinutes, inSeconds);

    const checkoutDate = new Date();
    checkoutDate.setHours(outHours, outMinutes, outSeconds);

   
    const diffMs = checkoutDate - checkinDate;

 
    const diffHrs = Math.floor(diffMs / 3600000);
    const diffMins = Math.floor((diffMs % 3600000) / 60000);
    const diffSecs = Math.floor((diffMs % 60000) / 1000);


    return `${diffHrs} hrs, ${diffMins} min, ${diffSecs} sec`;
  }

  
  return '00:00:00';
}

  }
}
</script>

<style >
p {
    margin-top: 0;
    margin-bottom: 0.1rem;
}

h2{
    margin-bottom: 0.1rem;   
}
.pngss{
   width: 20px;
}
</style>